import { componentWithCondition } from "../../newLayout/page/components/hoc/componentWithConditionCheck";
import { useSubmitBillMutation } from "../../../store/apiSlice/invoiceApiSlice";
import { SubmitBill } from "../../receipt/bill/components/submitBill";
import { useNotification } from "../../../hooks/useNotification";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

export const BillAction = ({ selectedOrderId, selectedOrderFromListview, setSelectedOrder }) => {
  const [isOpenSubmitModal, setIsOpenSubmitModal] = useState(false);
  const [submitBill, { isLoading }] = useSubmitBillMutation();
  const notify = useNotification();
  const navigate = useNavigate();

  const { name, status, id } = selectedOrderFromListview[0] || {};

  const closeSubmitModal = () => setIsOpenSubmitModal(false);

  const isDisabledSubmit = useMemo(
    () => !(selectedOrderId?.length === 1 && status?.id === "draft"),
    [selectedOrderId?.length, status?.id],
  );

  const createBill = () => navigate("create_general_bill");

  const handleSubmit = async () => {
    try {
      const res = await submitBill({ id }).unwrap();

      notify({
        type: "success",
        message: res?.message || "Your bill has been submitted successfully.",
      });
      setSelectedOrder([]);
    } catch (error) {
      const err = error?.data;

      if (err?.status) {
        notify({ type: "error", message: err?.status?.join(" ") });
      }
    }
    closeSubmitModal();
  };

  return (
    <>
      <li className={`tableButton  activeState`}>
        {" "}
        <button onClick={createBill}>Create Bill</button>
      </li>
      <li className={`tableButton ${!isDisabledSubmit ? "activeState" : ""}`}>
        <button disabled={isDisabledSubmit} onClick={() => setIsOpenSubmitModal(true)}>
          Submit Bill
        </button>
      </li>

      {isOpenSubmitModal && (
        <SubmitBill
          isLoading={isLoading}
          handleSubmit={handleSubmit}
          closeSubmitModal={closeSubmitModal}
          nameOfBill={name}
        />
      )}
    </>
  );
};

export const BillActionWithCheck = componentWithCondition(BillAction);
